import React from "react";

const ResponsiveImage = ({
  image,
  alt,
  className = "",
  sizes = "100vw",
  loading = "lazy",
  fetchPriority,
  ...rest
}) => {
  const srcSet = image.widths.map((w) => `/${image.base}-${w}w.webp ${w}w`).join(", ");
  return (
    <picture>
      <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      <img
        src={image.fallback}
        alt={alt}
        className={className}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        {...rest}
      />
    </picture>
  );
};

export default ResponsiveImage;
